import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Bridge Controller für das Verwalten der verschiedenen Modi, in denen die App sein kann (tabs und single-screen)

// Connects to data-controller="native--screen-mode"
export default class extends BridgeComponent {
  static component = "screen-mode"
  static values = {
    tabNavigation: Array,
    singleScreenUrl: String,
  }

  connect() {
    super.connect()
    this.dispatch("added", { prefix: false })
  }

  tabNavigationValueChanged() {
    if (this.tabNavigationValue.length > 0) {
      this.switchToModeTabs()
    }
  }

  singleScreenUrlValueChanged() {
    if (this.singleScreenUrlValue) {
      this.switchToModeSingleScreen()
    }
  }

  switchToModeTabs() {
    this.send("switchToModeTabs", { tabNavigation: this.tabNavigationValue })
  }

  switchToModeSingleScreen() {
    this.send("switchToModeSingleScreen", { url: this.singleScreenUrlValue })
  }

  reloadTabs({ params: { reloadActiveTab, clearAllTabs } }) {
    reloadActiveTab = reloadActiveTab || false
    clearAllTabs = clearAllTabs || false // clearAllTabs = Stack einreissen. Ansonsten lediglich neu laden
    this.send("reloadTabs", { reloadActiveTab, clearAllTabs })
  }
}
